<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-body class="pt-50">
        <b-row>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="经纪姓名" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.brokerName"
              class="d-inline-block"
              placeholder="经纪姓名"
            />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户联系人" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.contactsName"
              class="d-inline-block"
              placeholder="客户联系人"
            />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户电话" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.contactsPhone"
              class="d-inline-block"
              placeholder="客户电话"
            />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户名称" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.customerName"
              class="d-inline-block"
              placeholder="客户名称"
            />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="推介单号" style="margin-bottom: 0;">
              <b-form-input
                v-model="searchParams.orderSN"
                class="d-inline-block"
                placeholder="推介单号"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="关联项目" style="margin-bottom: 0;">
              <b-form-input
                v-model="searchParams.projectName"
                class="d-inline-block"
                placeholder="关联项目"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="预约单号" style="margin-bottom: 0;">
              <b-form-input
                v-model="searchParams.subscribeOrderSn"
                class="d-inline-block"
                placeholder="预约单号"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="单据状态" style="margin-bottom: 0;">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="searchParams.status"
              :options="statusOptions"
              class="w-100"
              :reduce="val => val.value"
            />
            </b-form-group>
          </b-col>

          <!-- <b-col class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="success"
              class="mt-1"
            >
              导出
            </b-button>
          </b-col> -->
        </b-row>
      </b-card-body>
    </b-card>

    <b-row class="d-flex justify-content-between">
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" :class="searchParams.status === 0 ? 'card-border' : ''" @click="searchParams.status = 0">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-warning">
                    <feather-icon size="24" icon="BoxIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.totalNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 全部 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" @click="searchParams.status = 2" :class="searchParams.status === 2 ? 'card-border' : ''">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-info">
                    <feather-icon size="24" icon="NavigationIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.verifingNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 待审核 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" @click="searchParams.status = 4" :class="searchParams.status === 4 ? 'card-border' : ''">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-success">
                    <feather-icon size="24" icon="CheckSquareIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.succeedNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 已通过 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" @click="searchParams.status = 5" :class="searchParams.status === 5 ? 'card-border' : ''">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-primary">
                    <feather-icon size="24" icon="PocketIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.generatedNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 已生单 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
    </b-row>

    <b-card>
      <b-row class="mb-50">
        <b-col cols="12" md="6" class="mb-md-0 d-flex">
          <b-button-group size="sm">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              @click="visible_coumn = true"
            > 全量 </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :pressed="!visible_coumn"
              @click="visible_coumn = false"
            > 精简 </b-button>
          </b-button-group>
        </b-col>
        <!-- :to="{ name: 'order-new'}" -->
        <!-- <b-col cols="12" md="6" class="mb-md-0 d-flex justify-content-end align-items-end">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary"> 新建推介客户单 </b-button>
        </b-col> -->
      </b-row>

      <!-- table -->
      <vxe-table
        ref="xTable"
        :column-config="{resizable: true}"
        border
        :auto-resize="true"
        :data="tableData"
        keep-source
        highlight-current-row
        :loading="loading"
        :cell-class-name="cellClassName"
        :scroll-x="{enabled: true}"
        :scroll-y="{enabled: true}"
      >
        <vxe-table-column field="id" title="ID" width="90" align="center" :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="orderSn" title="推介单号" width="150" align="center"></vxe-table-column>
        <vxe-table-column field="createdAt" title="创建时间" width="180" :visible="visible_coumn" align="center"></vxe-table-column>
        <vxe-table-column field="realArrivalTime" title="实际到访时间" width="180" show-overflow align="center"></vxe-table-column>
        <vxe-table-column field="brokerName" title="经纪姓名" min-width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="projectName" title="推介项目" min-width="160" show-overflow></vxe-table-column>
        <vxe-table-column field="customerName" title="客户名称" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="contactsName" title="客户联系人" width="100" show-overflow align="center"></vxe-table-column>
        <vxe-table-column field="contactsPhone" title="客户联系方式" width="130" show-overflow align="center"></vxe-table-column>
        <vxe-table-column field="contactsPosition" title="客户职位" width="150" show-overflow align="center" :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="officeAddress" title="现办公地址" width="180" show-overflow align="center" :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="recommendTime" title="推荐日期" width="180" show-overflow align="center" :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="customerIndustry" title="客户行业" width="120" show-overflow align="center" :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="rentDate" title="预计起租日期" width="180" show-overflow align="center" :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="needArea" title="意向面积" width="100" show-overflow :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="subscribeOrderSn" title="预约单号" min-width="150" show-overflow :visible="visible_coumn">
          <template v-slot="{ row }">
            <div>{{ row.subscribeOrderSn ? row.subscribeOrderSn : '手动创建' }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="companyCard" title="营业执照" min-width="90" align="center" show-overflow>
          <template v-slot="{ row }">
            <viewer><b-img :src="row.companyCard" height="32" width="32" class="d-inline-block"/></viewer>
          </template>
        </vxe-table-column>
        <vxe-table-column field="attachments" title="现场图片" min-width="130" show-overflow>
          <template v-slot="{ row }">
            <viewer>
              <b-img v-for="(item,index) in row.attachments" :key="index" :src="item" height="32" width="32" class="d-inline-block mx-50"/>
            </viewer>
          </template>
        </vxe-table-column>
        <vxe-table-column field="verifyAdminUserName" title="审核人员" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="verifyRemark" title="审核备注" min-width="150" show-overflow :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="verifyTime" title="审核时间" width="180" align="center" :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="status" title="单据状态" width="100" align="center">
          <template v-slot="{ row }">
            <b-badge pill v-if="row.status === -1" class="px-1 py-50" variant="light-danger"> 已禁用 </b-badge>
            <b-badge pill v-else-if="row.status === 1" class="px-1 py-50" variant="light-secondary"> 草稿中 </b-badge>
            <b-badge pill v-else-if="row.status === 2" class="px-1 py-50" variant="light-info"> 待审核 </b-badge>
            <b-badge pill v-else-if="row.status === 3" class="px-1 py-50" variant="light-warning"> 已驳回 </b-badge>
            <b-badge pill v-else-if="row.status === 4" class="px-1 py-50" variant="light-success"> 已通过 </b-badge>
            <b-badge pill v-else-if="row.status === 5" class="px-1 py-50" variant="light-primary"> 已生单 </b-badge>
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" title="操作" align="center" fixed="right" width="160">
          <template v-slot="{ row }">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-if="$can('info', 'broker-recommend')"
                variant="flat-primary" class="btn-icon" size="sm" @click="infoObject = row, info_show = true"
              >
                <!-- <feather-icon icon="EyeIcon" class="cursor-pointer text-body" size="16" /> -->
                查看
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-if="row.status === 2 && $can('verify', 'broker-recommend')"
                variant="flat-primary" class="btn-icon" size="sm" @click="verify_id = row.id, verify_time = row.realArrivalTime, verify_show = true"
              >
                <!-- <feather-icon icon="CheckSquareIcon" class="cursor-pointer text-body" size="16" /> -->
                审核
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-if="(row.status === 2 || row.status === 4 || row.status === 5) && $can('print', 'broker-recommend')"
                variant="flat-primary" class="btn-icon" size="sm" @click="download(row)"
              >
                <!-- <feather-icon icon="DownloadIcon" class="cursor-pointer text-body" size="16" /> -->
                下载
            </b-button>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex align-items-center mb-0 mt-1">
          <Select v-model="searchParams.size" class="mr-1">
            <Option v-for="item in pageOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <span class="text-nowrap"> 共 {{ total }} 条记录 </span>
        </div>
        <div class="d-flex align-items-center">
          <b-pagination v-model="searchParams.page" :total-rows="total" :per-page="searchParams.size" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
          <div class="d-flex align-items-center mb-0 mt-1 ml-1">
            <span class="text-nowrap">跳至</span>
            <Input @on-enter="pageToChange"
              v-model="pageTo" type="number" number class="mx-1" style="width: 5rem;"/>
            <span class="text-nowrap">页</span>
          </div>
        </div>
      </div>
    </b-card>

    <verify v-model="verify_show" title="推介客户单审核" :id="verify_id" :time="verify_time" @up-verify="verifyEvent" />

    <info v-model="info_show" :formUpdate="infoObject" @verify-event="(id,time) => { verify_id = id, verify_time = time, verify_show = true }" />
  </div>

</template>

<script>
import vSelect from 'vue-select'
import { ref, watch, onMounted, nextTick } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { recommendCustomerListApi, recommendCustomerVerifyApi } from '@/api/broker/recommendCustomer.js'
import { $urlConfig } from '@themeConfig'
import request from '@/auth/jwt/useJwt'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import verify from './verify.vue'
import info from './info.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BCardActions,
    verify,
    info,
  },
  setup(props, context) {
    /* 必要组件加载区域 */

    // 权限组件 弹出确认组件
    const { $can, $swal } = context.root
    // 消息提醒组件
    const toast = useToast()

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */
    // 表格加载控制 表格数据
    const loading = ref(false)
    const tableData = ref([])
    // 页码选择
    const pageOptions = ref([
      { label: '10 条/页', value: 10 },
      { label: '20 条/页', value: 20 },
      { label: '50 条/页', value: 50 },
    ])
    // 状态条件
    const statusOptions = ref([
      { label: '全部', value: 0 },
      { label: '草稿中', value: 1 },
      { label: '待审核', value: 2 },
      { label: '已驳回', value: 3 },
      { label: '已通过', value: 4 },
      { label: '已生单', value: 5 },
      { label: '已禁用', value: -1 },
    ])
    // 统计数据
    const statistic = ref({ generatedNum: 0, succeedNum: 0, totalNum: 0, verifingNum: 0 })

    // 数量
    const total = ref(0)
    // 控制多余表数据显示否
    const visible_coumn = ref(false)
    // 表格对象DOM
    const xTable = ref(null)
    // 查询条件
    
    const searchParams = ref({
      page: 1, size: 10,
      brokerID: null, brokerName: '', contactsName: '', contactsPhone: '', customerName: '',  orderSN: '', status: 0, projectName: '', subscribeOrderSN: ''
    })
    const pageTo = ref(null)
    // 指定页码操作
    const pageToChange = () => {
      const count = Math.ceil(total.value / searchParams.value.size)
      if (pageTo.value < 1) {
        pageTo.value = 1
      } else if (pageTo.value > count) {
        pageTo.value = count
      } else {
        pageTo.value = parseInt(pageTo.value, 0)
      }
      searchParams.value.page = pageTo.value
    }
    // 审核相关操作
    const verify_id = ref(null)
    const verify_show = ref(false)
    const verify_time = ref('')

    // 查看相关操作
    const infoObject = ref({})
    const info_show = ref(false)

    /* 接口调用区域 */
    const cellClassName = ({ column }) => { if (column.property === 'action' || column.property === 'status') { return 'vxe-table-padding' } }

    // 获取列表
    const fetchData = () => {
      recommendCustomerListApi(searchParams.value)
        .then(res => {
          tableData.value = res.data.list
          total.value = res.data.total
          statistic.value = res.data.statistic
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '获取推介客户单列表信息失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 导出
    const exportData = id => {
      toast({
        component: ToastificationContent,
        props: {
          title: '推介客户单文档',
          text: '正在项目推介客户单文档附件,请稍等!',
          icon: 'DownloadCloudIcon',
          variant: 'info'
        },
      })

      fetch(
        `${$urlConfig.apiBaseURL}/customer-order/wordExport?id=${id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `${request.jwtConfig.tokenType} ${request.getToken()}`,
          },
          mode: 'cors',
          // mode: 'no-cors',
        }
      )
        .then(response => {
          response.blob().then(blob => {
            const link = document.createElement('a')
            link.style.display = 'none'
            // a 标签的 download 属性就是下载下来的文件名
            link.download = `项目推介客户单-${new Date().toLocaleDateString()}.docx`
            link.href = URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            // 释放的 URL 对象以及移除 a 标签
            URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          })
        })
    }

    const download = row => {
      $swal({
        title: '推介单打印文档',
        text: '您确定下载项目客户推介单打印文档吗?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => { if (result.value) {  exportData(row.id) } })
    }

    // 审核客户预约单
    const verifyEvent = (id, data) => {
      let status = 0
      if (data.status === 3) status = 4
      else status = 3
      recommendCustomerVerifyApi({
        id,
        status,
        realArrivalTime: data.time,
        verifyRemark: data.remark,
      })
        .then(() => {
          fetchData()
          info_show.value = false
          toast({
            component: ToastificationContent,
            props: { title: '推介客户单审核成功', icon: 'CheckCircleIcon', variant: 'success' },
          })
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '推介客户单审核失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 条件筛选 下拉选择分类 选择项

    /* 组件内部逻辑处理，生命周期问题处理区域 */

    // 处理基本下拉信息加载，权限判断等
    onMounted(() => {
      if ($can('list', 'broker-recommend')) {
        fetchData()
      } else {
        toast({
          component: ToastificationContent,
          props: { title: '您没有推介客户单列表的权限', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      }
    })

    // 刷新查询
    watch(searchParams.value, () => { fetchData() })

    // 表格数据显示方式
    watch(visible_coumn, () => {
      nextTick(() => { xTable.value.refreshColumn() })
    })

    return {
      loading,
      tableData,
      total,
      xTable,

      pageOptions,
      searchParams,
      pageTo,
      pageToChange,
      statusOptions,

      fetchData,
      download,

      visible_coumn,
      // 审核相关
      verify_id,
      verify_show,
      verify_time,

      verifyEvent,

      infoObject,
      info_show,

      statistic,
      cellClassName,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
